import { initialState } from "./state";

export const news = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NEWS_LIST": {
      return Object.assign({}, state, {
        newsList: action.data
      });
    }
    case "SET_ACTIVE_NEWS": {
      return Object.assign({}, state, {
        activeNews: action.data
      });
    }
    default:
      return state;
  }
};
